module.exports = __webpack_public_path__ + "static/media/courseAI.b3678a9b.svg";